export const trustPilots = [
  {
    author: 'Mark D.',
    description:
      'Trademark Genius helped register my companies trademark. The process was simple, their customer service was excellent, and my trademark was registered without any issues. Highly recommend Trademark Genius.',
  },
  {
    author: 'Terry F.',
    description:
      'Got my trademark registered with USPTO without any issues. Their dashboard is a great tool and helped me track the progress of my application all the way to completion. Will use them again for any other TM needs.',
  },
  {
    author: 'Lisa N.',
    description:
      'My trademark registration was a unique situation that required some extra work, the team helped guide me through this daunting process and got my application submit to USPTO (and was approved without issues) Thanks TMG!',
  },
  {
    author: 'Kelly T.',
    description:
      'I contacted Trademark Genius after running into many issues trying to register my companies trademark myself. They helped solve every issue i ran into. Would definitely recommend spending the money to have professionals handle this process.',
  },
  {
    author: 'Jacob J.',
    description:
      'Submit my application, they reviewed it and identified some mistakes that would have caused a rejection. We fixed those and my trademark was approved. A+',
  },
  {
    author: 'Guy H.',
    description:
      'Decided to use Trademark Genius to trademark my business name. The process was easy with no unexpected issues. I will be using them again for any future trademarking needs.',
  },
  {
    author: 'Esther H.',
    description:
      'The staff here knows what they are doing, I used them to file 2 trademarks this year, both were approved by the USPTO. I would recommend them to anyone looking to file without issues.',
  },
];
